import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { useGenGridCol } from "src/utils/HelperComp";

import { TableColumnKey } from "../types/Table";
import useOperationButton from "./useOperationButton";
import { FeatureCode } from "@wallet-manager/node-types";

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { renderOperationButtons } = useOperationButton();
  const { hasPermission } = usePermission();

  const haveRefreshPermission = hasPermission(
    FeatureCode.FeaturesAssetManagement.TronRentResourceRecords.Refresh,
  );
  const haveReRentPermission = hasPermission(
    FeatureCode.FeaturesAssetManagement.TronRentResourceRecords.ReRent,
  );
  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationButtons,
      minWidth: 200,
      hide: !haveRefreshPermission && !haveReRentPermission,
    }),
    useGenGridCol(TableColumnKey.BatchId, t(TableColumnKey.BatchId)),
    useGenGridCol(TableColumnKey.MerchantName, t(TableColumnKey.MerchantName), {
      minWidth: 150,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(
      TableColumnKey.OperationType,
      t(TableColumnKey.OperationType),
    ),
    useGenGridCol(TableColumnKey.StepSeq, t(TableColumnKey.StepSeq)),
    useGenGridCol(
      TableColumnKey.TransactionSequence,
      t(TableColumnKey.TransactionSequence),
      { minWidth: 130 },
    ),
    useGenGridCol(
      TableColumnKey.FreeBandwidthOnly,
      t(TableColumnKey.FreeBandwidthOnly),
      { minWidth: 130 },
    ),
    useGenGridCol(
      TableColumnKey.WalletAddress,
      t(TableColumnKey.WalletAddress),
      {
        minWidth: 260,
      },
    ),
    useGenGridCol(TableColumnKey.Status, t(TableColumnKey.Status)),
    useGenGridCol(
      TableColumnKey.ActualRequiredEnergy,
      t(TableColumnKey.ActualRequiredEnergy),
    ),
    useGenGridCol(
      TableColumnKey.actualFreeActualDelegateRequiredBandwidth,
      t(TableColumnKey.actualFreeActualDelegateRequiredBandwidth),
    ),
    useGenGridCol(
      TableColumnKey.RequestedEnergy,
      t(TableColumnKey.RequestedEnergy),
      {
        minWidth: 120,
      },
    ),
    useGenGridCol(
      TableColumnKey.RequestedEnergyCost,
      t(TableColumnKey.RequestedEnergyCost),
      {
        minWidth: 150,
      },
    ),
    useGenGridCol(
      TableColumnKey.RequestedBandwidth,
      t(TableColumnKey.RequestedBandwidth),
      {
        minWidth: 140,
      },
    ),
    useGenGridCol(
      TableColumnKey.RequestedBandwidthCost,
      t(TableColumnKey.RequestedBandwidthCost),
      {
        minWidth: 150,
      },
    ),
    // useGenGridCol(
    //   TableColumnKey.LastBandwidthBlockNumber,
    //   t(TableColumnKey.LastBandwidthBlockNumber),
    //   { minWidth: 170 }
    // ),
    useGenGridCol(
      TableColumnKey.LastFreeBandwidth,
      t(TableColumnKey.LastFreeBandwidth),
    ),
    useGenGridCol(
      TableColumnKey.LastDelegateBandwidth,
      t(TableColumnKey.LastDelegateBandwidth),
    ),
    // useGenGridCol(
    //   TableColumnKey.LastEnergyBlockNumber,
    //   t(TableColumnKey.LastEnergyBlockNumber),
    //   { minWidth: 150 }
    // ),
    useGenGridCol(TableColumnKey.LastEnergy, t(TableColumnKey.LastEnergy)),
    useGenGridCol(TableColumnKey.CreationTime, t(TableColumnKey.CreationTime), {
      minWidth: 130,
    }),
    useGenGridCol(
      TableColumnKey.LastModifiedTime,
      t(TableColumnKey.LastModifiedTime),
      {
        minWidth: 130,
      },
    ),
  ];
  return { columns };
};

export default useTableColumns;
